// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "index" + "." + "84a0198c00470f476be9" + ".css";
};